import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";

const Link = styled(RouterLink)`
  font-weight: ${(props) => props.fontWeight};
  color: ${(props) => props.color};
`;

export default Link;
